import { render } from "./CapitalTab.vue?vue&type=template&id=ae17f65a"
import script from "./CapitalTab.vue?vue&type=script&lang=ts"
export * from "./CapitalTab.vue?vue&type=script&lang=ts"
script.render = render

export default script